import { ComponentMetadataModel } from '../../../api/api';
import { DialogActionMetadata } from './DialogActionMetadata';
import { ListItemMetadata } from './ListItemMetadata';
import { ListMessageChatItemMetadata } from './ListMessageChatItemMetadata';
import { ListWithSideDetailItemMetadata } from './ListWithSideDetailItemMetadata';
import { TableColumnActionMetadata } from './TableColumnActionMetadata';

/**
 * Defines metadata for virtual component types that don't exist as real components
 * but need to be selectable and editable in the designer (e.g., DialogAction).
 * Registry of all virtual component metadata.
 * These will be merged into the componentByName map in UserInterfaceMetadataContext.
 */
export const VirtualComponentMetadata: ComponentMetadataModel[] = [
	DialogActionMetadata,
	ListItemMetadata,
	ListMessageChatItemMetadata,
	ListWithSideDetailItemMetadata,
	TableColumnActionMetadata,
];
